import { Dispatch } from 'redux';
import {
  closeSuccessPromotionAlertModal,
  openFailurePaymentAlertModal,
  openFailureWebViewPaymentStatusAlertModal,
  openSuccessWebViewPaymentStatusAlertModal
} from '../../actions';
import { PaymentSuccessData } from '../../store/types';

export const closeLegacyPaymentAlertModals = (dispatch: Dispatch) => {
  dispatch(openFailurePaymentAlertModal({ isVisible: false, name: '' }));
  dispatch(closeSuccessPromotionAlertModal());
};

export const dispatchWebViewSuccessPaymentStatus = (
  dispatch: Dispatch,
  params: PaymentSuccessData | null
) => {
  closeLegacyPaymentAlertModals(dispatch);
  dispatch(openSuccessWebViewPaymentStatusAlertModal(params));
};

export const dispatchWebViewFailurePaymentStatus = (
  dispatch: Dispatch,
  type: 'error' | 'warning' = 'error',
  errorMessage: string | null = null
) => {
  closeLegacyPaymentAlertModals(dispatch);
  dispatch(
    openFailureWebViewPaymentStatusAlertModal({
      isVisible: true,
      type,
      errorMessage
    })
  );
};
